import {
  defaultPersonBidragColumns,
  defaultPersonHistorik2Columns,
  defaultPersonHistorikColumns,
  defaultUdenlandskAdvokatsamfundColumns,
} from "../../config/person";
import {
  PersonTilsyn,
  PersonKontaktadresse,
  PersonForsikring,
  PersonDto,
  PersonBeregnetAdresse,
  PersonPersonart,
  PersonBeskikkelse,
  PersonFirma,
  PersonPrincipal,
  PersonPersontype,
  PersonInteresse,
  PersonTilsynserklaering,
  PersonEfteruddannelse,
  PersonKlienterklaering,
  PersonDisciplinaerstatus,
  PersonSanktion,
  Fmuretssagsproeve,
  KursusPerson,
  PersonKorrespondance,
  PersonForening,
  PersonUdvalg,
  PersonAbonnement,
  PersonBetalingsadresse,
  PersonBidragsopkraevning,
  Personhistorik,
  PersonUdenlandskadvokatsamfund,
  Personhistorik2,
} from "../../interfaces/schema";
import { getFields } from "../../util/graphqlUtil";
import { Field } from "../../util/typeUtil";

export const personBetalingsadresseFields = getFields<
  Field<PersonBetalingsadresse, 1>
>([
  "opretDato",
  "retteDato",
  "opretInit",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "adresse.adresselinie1",
  "adresse.adresselinie2",
  "adresse.adresselinie4",
  "adresse.postnummer",
  "adresse.bynavn",
  "adresse.landekode",
  "adresse.toLines",
  "adresse.darAdresseId",
  "adresse.coNavn",
  "bemaerkning",
  "email",
]);

export const personAbonnementFields = getFields<Field<PersonAbonnement, 1>>([
  "faktureres",
  "antalEksemplar",
  "sidsteOpkraevning",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "abonnementNrNavigation.nr",
  "abonnementNrNavigation.navn",
]);

export const personUdvalgFields = getFields<Field<PersonUdvalg, 1>>([
  "tillidshvervNr",
  "fratraadtAarsag",
  "opretInit",
  "opretDato",
  "retteInit",
  "retteDato",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "udvalg.navn",
  "udvalg.id",
  "tillidshvervNrNavigation.navn",
  "tillidshvervNrNavigation.nr",
]);

export const personHistorikFields = getFields<Field<Personhistorik, 3>>(
  defaultPersonHistorikColumns.map((e) => e.field),
);
export const personHistorik2Fields = getFields<Field<Personhistorik2, 3>>(
  defaultPersonHistorik2Columns.map((e) => e.field),
);

export const foreningPersonFields = getFields<Field<PersonForening, 1>>([
  "sidsteOpkraevning",
  "lbNr",
  "sidsteOpkraevning",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "forening.navn",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
]);

export const personKorrespondanceFields = getFields<
  Field<PersonKorrespondance, 1>
>([
  "dokumentNr",
  "beskrivelse",
  "navn",
  "filnavn",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
]);

export const kursusPersonFields = getFields<Field<KursusPerson, 2>>([
  "eksamensdato",
  "ikkeGennemfoert",
  "bestaaetMark",
  "tilmeldtRaekkefoelge",
  "tilmeldDato",
  "opretDato",
  "retteDato",
  "opretInit",
  "retteInit",
  "deltagerStatusNavigation.navn",
  "deltagerStatusNavigation.nr",
  "fakturaStatusNavigation.navn",
  "fakturaStatusNavigation.nr",
  "overnatningstypeNavigation.navn",
  "overnatningstypeNavigation.nr",
  "hold.id",
  "hold.bemaerkninger",
  "hold.navn",
  "hold.fraDato",
  "hold.tilDato",
  "hold.hotelNavigation.navn1",
  "hold.kursustypeNavigation.navn",
  "hold.kursustypeNavigation.nr",
  "bestaaetMark",
]);

export const fmuretssagsproeveFields = getFields<Field<Fmuretssagsproeve, 3>>([
  "nr",
  "proceduredato",
  "notat",
  "fakturaStatus",
  "retNavigation.navn1",
  "censorNavigation.fuldtNavn",
  "censorPersonId",
  "statusNavigation.navn",
  "fakturaStatusNavigation.navn",
  "eksaminandNavigation.id",
  "eksaminandNavigation.fuldtNavn",
  "eksaminandNavigation.personFirma.firma.id",
  "eksaminandNavigation.personFirma.firma.navn1",
  "eksaminandNavigation.personFirma.periode.fraDato",
  "fiktiv",
  "tidspunkt",
  "adresse",
  "bsNummer",
  "dommernavn",
  "antalDommere",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "status",
]);

export const personSanktionFields = getFields<Field<PersonSanktion, 1>>([
  "sagsNr",
  "bemaerkninger",
  "sagsLink",
  "afgoerelseskoder",
  "naevnskendelseDato",
  "naevnskendelseBoedebeloeb",
  "indbragtretten",
  "retskendelseDato",
  "retskendelseBoedebeloeb",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "naevnskendelseSanktionstypeNrNavigation.navn",
  "naevnskendelseSanktionstypeNrNavigation.nr",
  "retskendelseSanktionstypeNrNavigation.navn",
  "retskendelseSanktionstypeNrNavigation.nr",
]);

export const personDisciplinaerstatusFields = getFields<
  Field<PersonDisciplinaerstatus, 1>
>([
  "esdhSagsNr",
  "bemaerkning",
  "opretDato",
  "opretInit",
  "retteInit",
  "retteDato",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "disciplinaerstatustypeNrNavigation.navn",
  "disciplinaerstatustypeNrNavigation.nr",
]);

export const personKlienterklaeringFields = getFields<
  Field<PersonKlienterklaering, 1>
>([
  "erklAar",
  "firmaCvrNr",
  "erklModtaget",
  "erklNr",
  "frist",
  "koerselDato",
  "erklNrWeb",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "frist",
  "klienterklaeringstypeNavigation.navn",
  "klienterklaeringstypeNavigation.nr",
  "klienterklaeringStatusNavigation.navn",
  "klienterklaeringStatusNavigation.nr",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
]);

export const personEfteruddannelseFields = getFields<
  Field<PersonEfteruddannelse, 3>
>([
  "lektionerGennemfoert",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "bemaerkning",
  "periode.fraDato",
  "periode.tilDato",
  "periode.tilDatoInklusiv",
  "personEfteruddannelseIndberetning.id",
  "personEfteruddannelseIndberetning.indberetningFrist",
  "personEfteruddannelseIndberetning.registreringsDato",
  "personEfteruddannelseIndberetning.signaturNavn",
  "personEfteruddannelseIndberetning.efteruddannelseIndberetningstype",
  "personEfteruddannelseIndberetning.personEfteruddannelseIndberetningLinje.id",
  "personEfteruddannelseIndberetning.personEfteruddannelseIndberetningLinje.indberettedeLektioner",
  "personEfteruddannelseIndberetning.personEfteruddannelseIndberetningLinje.efteruddannelsestypenr",
  "personEfteruddannelseIndberetning.personEfteruddannelseIndberetningLinje.efteruddannelsestypenrNavigation.navn",
  "personEfteruddannelseIndberetning.efteruddannelseIndberetningStatus",
  "personEfteruddannelseIndberetning.efteruddannelseIndberetningStatusNavigation.navn",
]);

export const personTilsynserklaeringFields = getFields<
  Field<PersonTilsynserklaering, 1>
>([
  "erklAar",
  "erklModtaget",
  "koerselDato",
  "forsikringDaekning",
  "forsikringPolice",
  "forsikringSelskab",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "tilsynserklaeringStatusNavigation.navn",
  "tilsynserklaeringStatusNavigation.nr",
  "frist",
]);

export const personInteresseFields = getFields<Field<PersonInteresse, 2>>([
  "interesseId",
  "opretDato",
  "retteDato",
  "opretInit",
  "retteInit",
  "interesse.id",
  "interesse.forkortelse",
  "interesse.navn",
  "interesse.beskrivelse",
  "interesse.interesseGroup.id",
  "interesse.interesseGroup.synonym",
]);

export const personPersontypeFields = getFields<Field<PersonPersontype, 1>>([
  "persontypeNr",
  "opretDato",
  "retteDato",
  "opretInit",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "persontypeNrNavigation.navn",
  "persontypeNrNavigation.nr",
]);

export const personPrincipalFields = getFields<Field<PersonPrincipal, 1>>([
  "opretDato",
  "retteDato",
  "opretInit",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "personFuldm.id",
  "personFuldm.kundeNr",
  "personFuldm.fuldtNavn",
  "personPrincipalNavigation.id",
  "personPrincipalNavigation.kundeNr",
  "personPrincipalNavigation.fuldtNavn",
  "personPrincipalNavigation.prioriteretEmail",
]);

export const personFirmaFields = getFields<Field<PersonFirma, 3>>([
  "bemaerkninger",
  "emailArbejde",
  "fakturaReference",
  "priorieteretPrimaerFra",
  "opretDato",
  "retteDato",
  "opretInit",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "personfirmatypeNrNavigation.navn",
  "personfirmatypeNrNavigation.nr",
  "firma.id",
  "firma.cvrNr",
  "firma.emailSikker",
  "firma.firmaNr",
  "firma.navn1",
  "firma.tlf",
  "firma.email",
  "firma.ean",
  "firma.fakturaEmail",
  "firma.fakturaAfsendelse",
  "firma.periode.fraDato",
  "firma.periode.tilDatoInklusiv",
  "firma.fakturaAfsendelseNavigation.navn",
  "firma.fakturaAfsendelseNavigation.nr",
  "firma.beliggenhedsadresse.toLines",
  "firma.beliggenhedsadresse.landNavigation.navn",
]);

export const personBeskikkelseFields = getFields<Field<PersonBeskikkelse, 1>>([
  "aarsag",
  "opretDato",
  "retteDato",
  "opretInit",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "beskikkelsestypeNavigation.navn",
  "beskikkelsestypeNavigation.nr",
]);

export const personUdenlandskadvokatsamfundFields = getFields<
  Field<PersonUdenlandskadvokatsamfund, 1>
>(defaultUdenlandskAdvokatsamfundColumns.map((e) => e.field) as any);

export const personPersonartFields = getFields<Field<PersonPersonart, 1>>(
  [
    "periode.fraDato",
    "periode.tilDatoInklusiv",
    "personartNrNavigation.navn",
    "personartNrNavigation.nr",
  ],
  true,
);

export const personBeregnetAdresseFields = getFields<
  Field<PersonBeregnetAdresse, 2>
>(
  [
    "adresse.adresselinie1",
    "adresse.adresselinie2",
    "adresse.adresselinie4",
    "adresse.postnummer",
    "adresse.bynavn",
    "adresse.landekode",
    "adresse.toLines",
    "adresse.darAdresseId",
    "adresse.coNavn",
    "adresse.landNavigation.id",
    "adresse.landNavigation.navn",
  ],
  true,
);

export const personTilsynFields = getFields<Field<PersonTilsyn, 1>>([
  "sagsNr",
  "gennemfoerselDato",
  "bemaerkning",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "personTilsynstype",
  "personTilsynstypeNavigation.navn",
]);

export const personKontaktadresseFields = getFields<
  Field<PersonKontaktadresse, 2>
>([
  "personId",
  "attention",
  "bemaerkning",
  "retteInit",
  "retteDato",
  "opretInit",
  "opretDato",
  "adresse.adresselinie1",
  "adresse.adresselinie2",
  "adresse.adresselinie4",
  "adresse.postnummer",
  "adresse.bynavn",
  "adresse.landekode",
  "adresse.toLines",
  "adresse.darAdresseId",
  "adresse.coNavn",
  "adresse.landNavigation.navn",
  "adresse.landNavigation.id",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
]);

export const personForsikringFields = getFields<Field<PersonForsikring, 1>>([
  "policeNr",
  "restance",
  "garantiordning",
  "notat",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "periode.fraDato",
  "periode.tilDatoInklusiv",
  "forsikringsselskab.id",
  "forsikringsselskab.navn1",
  "forsikringsselskab.forsikringsselskabNr",
]);

export const personBidragsopkraevningFields = getFields<
  Field<PersonBidragsopkraevning, 1>
>(defaultPersonBidragColumns.map((e) => e.field) as any);

export const personFields = getFields<Field<PersonDto, 3>>([
  "fuldtNavn",
  "kundeNr",
  "foedselsDato",
  "harCprNummer",
  "koen",
  "titelId",
  "fornavne",
  "efternavn",
  "tlfMobilNr",
  "emailPrivat",
  "auktionsleder",
  "advokatnoeglen",
  "bemaerkninger",
  "personDoedDato",
  "erUdoevende",
  "prioriterEmailPrivat",
  "opretDato",
  "opretInit",
  "retteDato",
  "retteInit",
  "titel.id",
  "titel.navn",
  "titel1.id",
  "titel1.navn",
  "adresse.adresse.landNavigation.navn",
  "adresse.adresse.toLines",
  "foersteBeskikkelse.beskikkelsestypeNavigation.nr",
  "prioriteretEmail",
]);
